import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
  import { debounce } from 'lodash';

  import Modal from '@/components/common/Modal.vue';

  import { Multiselect } from 'vue-multiselect';
  import { useToasted } from '@/helpers';

  
  import { defineComponent } from 'vue';
  import { getStopLocations } from '@/api/transport';
  import { TrafiklabStops } from '@/types/api/transport';

  const __default__ = defineComponent({
    name: 'CreateTrafiklabWidgetModal',
  });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['createWidget', 'closeModal'],
  setup(__props, { emit: emits }) {

  

  const toasted = useToasted();

  const showModal = ref(false);
  const stopSearchKey = ref('');
  const trafiklabStops = ref<TrafiklabStops[]>([]);
  const selectedStop = ref<TrafiklabStops | null>(null);
  const isSaving = ref(false);
  const widgetName = ref('Trafiklab');
  const loading = ref(false);

  onMounted(() => {
    showModal.value = true;
  });

  const disableOkButton = computed(() => {
    return widgetName.value.length < 3 || !selectedStop.value;
  });

  const searchStop = debounce((searchValue = '') => {
    stopSearchKey.value = searchValue;

    if (!stopSearchKey.value) return;
    loading.value = true;

    getStopLocations(stopSearchKey.value)
      .then((stops: TrafiklabStops[]) => {
        trafiklabStops.value = stops.filter((stop) => !!stop.id);
      })
      .catch((err) => {
        toasted.global.general_error({ message: 'Failed to fetch the stops.' });
      })
      .finally(() => {
        loading.value = false;
      });
  }, 600);

  async function createTrafiklabWidget() {
    isSaving.value = true;

    const data = {
      name: widgetName.value,
      stop: selectedStop.value,
    };

    emits('createWidget', data);
    isSaving.value = false;
    closeModal();
  }

  function closeModal() {
    showModal.value = false;
    emits('closeModal');
  }

return { __sfc: true,emits, toasted, showModal, stopSearchKey, trafiklabStops, selectedStop, isSaving, widgetName, loading, disableOkButton, searchStop, createTrafiklabWidget, closeModal, Modal, Multiselect }
}

})